<template>
  <vg-field
      v-bind="$attrs"
      v-on="$listeners"
      :label="label"
      :value="projectName"
      :placeholder="`请选择${label}`"
      :disabled="disabled"
      readonly
      is-link
      @click="pick"
  />
</template>

<script>
import {mapState} from "pinia";
import useAuthnStore from "@/store/authn";
import useProfitCenterPickerStore from "@/store/profit-center-picker-store";
import VgField from "@/components/Commons/VgField.vue";
import dpApplicationFormStore from "@/store/dp-application-form-store";

export default {
  name: "DpApplicationProfitCenterField",
  components: {
    VgField,
  },
  props: {
    label: String,
    value: null,
  },
  created() {
    const cheetahId = this.leoParams?.projectId
    const profitCenterPicker = useProfitCenterPickerStore()

    profitCenterPicker.loadIfNull(cheetahId)
        .then((profitCenters) => {
          if (profitCenters?.length <= 1) {
            // 只有当费用中心只有一个时才自动选择第一个
            profitCenterPicker.pick(profitCenters[0])
            this.input(this.picked)
          }
        })
    this.input(this.picked)
  },
  computed: {
    ...mapState(useAuthnStore, ['leoParams', 'isTenant']),
    ...mapState(useProfitCenterPickerStore, ['picked', 'profitCenters']),
    projectName() {
      return this.picked?.projectName || ''
    },
    disabled() {
      if (this.isTenant) {
        return this.profitCenters?.length === 1
      }
      return false
    }
  },
  watch: {
    value(newValue) {
      useProfitCenterPickerStore().pick(newValue)
    },
    picked() {
      this.input(this.picked)
    }
  },
  methods: {
    input(value) {
      dpApplicationFormStore().clearDate()
      this.$emit('input', value)
    },
    pick() {
      if (this.disabled) {
        return
      }
      const cheetahId = this.leoParams?.projectId;
      if (cheetahId) {
        this.$router.push({
          name: 'leo-project-profit-centers-picker',
          params: {
            cheetahId: cheetahId,
          }
        });
      } else {
        this.$router.push({
          name: 'profit-centers-picker',
        });
      }
    }
  }
}
</script>

<style scoped>

</style>
